import { render, staticRenderFns } from "./SystemMessage.vue?vue&type=template&id=14514d44"
import script from "./SystemMessage.vue?vue&type=script&lang=ts"
export * from "./SystemMessage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports